import type { FC } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import ButtonText from '@segment/matcha/components/ButtonText'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import ComplianceImage from './ComplianceImage'

const copy = {
  overline: `Compliance`,
  heading: `Comply with global regulations`,
  description: `Our Data Processing Agreement meets the requirements of the GDPR, and we offer Standard Contractual Clauses for compliant data transfer. Additionally, our Privacy Policy is compliant with global privacy laws such as the GDPR and CCPA. Segment is also HIPAA-eligible and able to sign BAAs to receive, maintain, and transmit PHI on behalf of our customers in the healthcare industry.`,
}

const link = {
  text: `Learn about Segment Compliance`,
  url: `/security/#commitment-to-data-privacy`,
}

const Customer: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper id="compliance">
      <StyledSectionBase variant="2Col" copyVariant="narrow">
        <SectionCopy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h2" tag="h3">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pLarge">{copy.description}</CopyText.Description>
            <LinkWrapper size="medium" tag="a" href={getAbsoluteUrl(link.url, pageConfig)} iconEnd={ChevronRightIcon}>
              {link.text}
            </LinkWrapper>
          </CopyTextBase>
        </SectionCopy>

        <Section.Contents>
          <ComplianceImage />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  display: grid;
  ${({ theme }) => theme.breakpoints.down(`md`)} {
    padding-top: 45px;
  }
`

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.down(`md`)} {
      padding-top: 0;
      grid-template-areas:
        'contents'
        'copy';
    }
  }
`

const LinkWrapper = styled(ButtonText)`
  padding-top: 0;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default Customer
